module.exports = __webpack_public_path__ + "img/gun-lucifer.3d0e38d5.jpg";